import { OmitObjectPropertiesHelperBase } from './OmitObjectPropertiesHelperBase';
export class OmitPropertyObjectPropertiesHelper extends OmitObjectPropertiesHelperBase {
    getObject(sb) {
        return sb.helpers.getPropertyObject;
    }
}

//# sourceMappingURL=OmitPropertyObjectPropertiesHelper.js.map
